// extracted by mini-css-extract-plugin
module.exports = {"FootMenu":"FootMenu_FootMenu__1pqIO","Btn":"FootMenu_Btn__1pskZ","Icon":"FootMenu_Icon__31Ikm"};